import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ConversationCostService, ITagCost } from '../../services/conversation-cost.service';

@Component({
  selector: 'dc-cost-details',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './cost-details.component.html',
  styleUrls: ['./cost-details.component.scss'],
})
export class CostDetailsComponent {
  public conversationCostService = inject(ConversationCostService);
  public usageByTag = this.conversationCostService.usageByTag;

  get usageArray() {
    const usage = this.usageByTag();
    return Object.entries(usage).map(([tag, cost]) => ({
      tag,
      ...cost,
      inputCost: cost.tokenUsage.input * 0.0000001,
      outputCost: cost.tokenUsage.output * 0.0000004,
      totalCost: cost.tokenUsage.input * 0.0000001 + cost.tokenUsage.output * 0.0000004,
    }));
  }
}
